import moment from 'moment';

const generateUTCDateMoment = (momentDate: moment.Moment): moment.Moment => {
    return moment.utc([
        momentDate.year(),
        momentDate.month(),
        momentDate.date(),
    ]);
};

export default generateUTCDateMoment;
